import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Price from '../Price'
import styles from 'modules/Finance/Wallets/subcomponents/Chart/Chart.module.scss'

export const Legend = ({
  data: { categories = [], colors: COLORS, currency },
  categoryActiveType = '',
}) => {
  const { t } = useTranslation(['wallets'])
  const items = useMemo(
    () => categories.filter(([, value]) => value !== 0),
    [categories],
  )
  return (
    <div className={styles['chart__legenda-list']}>
      {items.map(([key, value], index) => (
        <div key={key} className={styles['chart__legenda-item']}>
          <a className={styles['chart__legenda-link']}>
            <span
              className={styles['chart__legenda-dot']}
              style={{ backgroundColor: COLORS[index] }}
            />
            {t(`chart.categories.${key}`, { context: categoryActiveType })}{' '}
            <Price
              className={styles['chart__legenda-price']}
              number={value}
              currency={currency}
            />
          </a>
        </div>
      ))}
    </div>
  )
}

Legend.propTypes = {
  data: PropTypes.shape({
    categories: PropTypes.array,
    colors: PropTypes.object,
    currency: PropTypes.string,
  }),
  className: PropTypes.string,
  categoryActiveType: PropTypes.oneOf(['in', 'out']),
}
